import React, {useEffect, useState} from 'react';
import {View} from 'react-native';

import Checkbox from '/component/base/Checkbox/Checkbox';
import Icon from '/component/base/Icon/Icon';
import Text from '/component/base/Text';
import ProfileSection from '/component/partial/profile/ProfileSection';
import {IconNameByType} from '/component/partial/UrlDetailsPopover/UrlDetailsPopover.util';
import {DownlineProfile} from '/constant/TestIDs';
import testProperties from '/util/testing/testProperties';

import {styles} from './ProfileContactSectionWithCheckbox.style';

export const ProfileContactSectionWithCheckbox = ({
  urlDetails = [],
  clientDetails = {},
  setSocialLinksStatus = () => {},
  handleCheckedLinksChange = () => {},
  setClientId = () => {},
}: any) => {
  const {
    id, // clientId need to send when we click on Merge profile
  } = clientDetails || {};

  const [links, setLinks] = useState(urlDetails);
  const [, setCheckedLinks] = useState([]);

  useEffect(() => {
    const initializedLinks = urlDetails?.map((link: any) => ({
      ...link,
      checkStatus: true,
    }));
    setLinks(initializedLinks);
  }, [urlDetails]);

  useEffect(() => {
    const newCheckedLinks = links?.filter((link: any) => link?.checkStatus);
    setCheckedLinks(newCheckedLinks);
    handleCheckedLinksChange(newCheckedLinks);
  }, [links]);

  const getDisabledIconStyleContact = (checkStatus: any) => {
    if (checkStatus) {
      return styles.selectedIcon;
    } else {
      return styles.unSelectedIcon;
    }
  };

  const getSocialUrlStylePropContact = (checkStatus: any) => {
    if (checkStatus) {
      return {...styles.disabledContainer, ...styles.taskItemContainer};
    } else {
      return {...styles.taskItemContainer, ...styles.enabledContainer};
    }
  };

  const getTaskItemIconContact = (checkStatus: any) =>
    checkStatus ? 'checkbox-selected' : 'checkbox-unselected';

  const updateStatus = () => {
    const isAnyChecked = links.some((link: any) => link.checkStatus);
    setSocialLinksStatus(isAnyChecked);
    setClientId(id);
  };

  const toggleCheckboxContact = (index: any) => {
    const updatedLinks = [...links];
    updatedLinks[index].checkStatus = !updatedLinks[index].checkStatus;
    setLinks(updatedLinks);
    updateStatus();
  };

  return (
    <ProfileSection analyticsTitle="Contact" style={{base: styles.base}}>
      {links?.length > 0 && (
        <Text
          allowFontScaling
          maxFontSizeMultiplier={2}
          style={styles.header}
          {...testProperties(DownlineProfile.profileSectionLinksLabel)}>
          Links
        </Text>
      )}
      {links?.map((urlDetail: any, index: any) => (
        <View
          style={[
            getSocialUrlStylePropContact(urlDetail?.checkStatus),
            styles.linkContainer,
          ]}
          {...testProperties(DownlineProfile.profileSectionTile)}>
          <View style={styles.iconContainer}>
            <Checkbox
              checkedIconName={getTaskItemIconContact(urlDetail?.checkStatus)}
              checked={urlDetail?.checkStatus}
              style={{
                icon: getDisabledIconStyleContact(urlDetail?.checkStatus),
              }}
              onChange={() => toggleCheckboxContact(index)}
              rectangleCheckbox
            />
          </View>
          <View>
            <View style={styles.linksIconLabel}>
              <View style={styles.iconAndLabelContainer}>
                <Icon
                  // @ts-expect-error TS(2769): No overload matches this call.
                  name={[IconNameByType[urlDetail?.type]]}
                  style={[styles.iconColumn]}
                  accessible={false}
                  {...testProperties(DownlineProfile.profileSectionUrlIcon)}
                />
                <Text
                  allowFontScaling
                  maxFontSizeMultiplier={2}
                  style={styles.socialText}
                  {...testProperties(DownlineProfile.profileSectionUrlType)}>
                  {urlDetail?.type}
                </Text>
              </View>

              <Text
                allowFontScaling
                maxFontSizeMultiplier={2}
                style={styles.urlText}
                {...testProperties(DownlineProfile.profileSectionUrlValue)}>
                {urlDetail?.url}
              </Text>
            </View>
          </View>
        </View>
      ))}
    </ProfileSection>
  );
};

export default ProfileContactSectionWithCheckbox;
